import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const RecentViewedSlider = () => {
    const [products, setProducts] = useState([]);
    const [perView, setPerView] = useState(() => {
        if (typeof window !== "undefined") {
            const width = window.innerWidth;
            if (width < 576) return 1;
            if (width < 768) return 2;
            if (width < 992) return 3;
        }
        return 4;
    });

    const [index, setIndex] = useState(perView);
    const autoMs = 4000;
    const viewportRef = useRef(null);
    const [transitioning, setTransitioning] = useState(true);
    const [hover, setHover] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("recentViews")) || [];
        setProducts(stored);
    }, []);

    const slides =
        products.length > 0
            ? [
                ...products.slice(-perView),
                ...products,
                ...products.slice(0, perView),
            ]
            : [];

    const updatePerView = () => {
        const width = window.innerWidth;
        if (width < 576) setPerView(1);
        else if (width < 768) setPerView(2);
        else if (width < 992) setPerView(3);
        else setPerView(5);
    };

    useEffect(() => {
        updatePerView();
        const handleResize = () => updatePerView();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => setIndex(perView), [perView]);

    const next = () => {
        if (products.length <= perView) return;
        setIndex((i) => i + 1);
    };

    const prev = () => {
        if (products.length <= perView) return;
        setIndex((i) => i - 1);
    };

    useEffect(() => {
        if (products.length <= perView || hover) return;
        const id = setInterval(next, autoMs);
        return () => clearInterval(id);
    }, [perView, products.length, hover]);

    useEffect(() => {
        if (products.length <= perView) return;

        if (index === slides.length - perView) {
            setTimeout(() => {
                setTransitioning(false);
                setIndex(perView);
            }, 600);
        }
        if (index === 0) {
            setTimeout(() => {
                setTransitioning(false);
                setIndex(slides.length - perView * 2);
            }, 600);
        }
    }, [index, slides.length, perView, products.length]);

    useEffect(() => {
        if (!transitioning) {
            const id = setTimeout(() => setTransitioning(true), 50);
            return () => clearTimeout(id);
        }
    }, [transitioning]);

    const handleProductClick = (productId) => {
        navigate(`/binstock/${productId}`);
    };

    const handleAddToCart = (product) => {
        let cart = JSON.parse(localStorage.getItem("cartItems")) || [];
        cart.push(product);
        localStorage.setItem("cartItems", JSON.stringify(cart));
    };

    if (!products || products.length === 0) return null;

    return (
        <div className="row mt-4">
            <div className="col-12">
                <div className="card shadow-none border-0">
                    <div className="card-body bg-white">
                        <h5 className="fw-bold mb-3 text-center text-primary">
                            Recently Viewed Products
                        </h5>

                        <div
                            className="recent-products-carousel position-relative"
                            onMouseEnter={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                        >
                            {products.length > perView && (
                                <>
                                    <button className="rp-arrow rp-left" onClick={prev}>
                                        <i className="bx bx-chevron-left fs-1 text-primary"></i>
                                    </button>

                                    <button className="rp-arrow rp-right" onClick={next}>
                                        <i className="bx bx-chevron-right fs-1 text-primary"></i>
                                    </button>
                                </>
                            )}

                            <div className="rp-viewport" ref={viewportRef}>
                                <div
                                    className="rp-track"
                                    style={{
                                        transform: `translateX(-${(index * 100) / perView}%)`,
                                        transition: transitioning ? "transform 0.6s ease" : "none",
                                    }}
                                >
                                    {slides.map((product, idx) => (
                                        <div className="rp-slide px-1" key={idx} style={{ width: `${100 / perView}%` }}>
                                            <div className="card h-100 m-0 position-relative">

                                                {/* Add to Cart Icon */}
                                                <span
                                                    className="add-cart-icon"
                                                    onClick={() => handleAddToCart(product)}
                                                >
                                                    <i className="bx bx-cart-add"></i>
                                                </span>

                                                <img
                                                    src={product.images?.[0] || "/assets/images/binstock/no-image.jpg"}
                                                    className="card-img-top"
                                                    alt={product.name}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = "/assets/images/binstock/no-image.jpg";
                                                    }}
                                                    onClick={() => handleProductClick(product.id)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecentViewedSlider;
